import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
//管理vuex
const store = new Vuex.Store({
	state: {
		is_loading: false,
		fun_buttons:{}
	},
	mutations: {//同步操作 commit
		UPDATALOADING: function(state, status) {
			state.is_loading = status;
		},
		UPDATAFUNLIST: function(state, status) {
			state.fun_buttons = status;
		}
	},
	actions:{//异步操作  dispatch
		updataFunList(context, status) {
			context.commit("UPDATAFUNLIST", status);
		},
	}
});
export default store;


// WEBPACK FOOTER //
// ./src/store/store.js